"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateInviteInfoRequest = void 0;
var UpdateInviteInfoRequest = /** @class */ (function () {
    function UpdateInviteInfoRequest() {
    }
    return UpdateInviteInfoRequest;
}());
exports.UpdateInviteInfoRequest = UpdateInviteInfoRequest;
;
//# sourceMappingURL=updateInviteInfo.request.js.map